export default {
  // Navbar
  'nav.home': 'Home',
  'nav.packaging': 'Products',
  'nav.customization': 'Customization',
  'nav.aiPreview': 'AI Preview',
  'nav.quotation': 'Quotation',
  'nav.howItWorks': 'How It Works',
  'nav.supplierNetwork': 'Supplier Network',
  'nav.qualityControl': 'Quality Control',
  'nav.aboutUs': 'About Us',
  'nav.contact': 'Contact',
  'nav.signIn': 'Sign In',
  'nav.getQuote': 'Get Quote',
  'nav.uploadImage': 'Upload Image',
  'nav.language': 'Language',
  'nav.currency': 'Currency',

  // Hero
  'hero.badge': 'Global B2B Cosmetic Packaging Portal',
  'hero.title': 'Find and Customize Cosmetic Packaging from Verified Chinese big Suppliers',
  'hero.subtitle': 'Search thousands of cosmetic containers, compare options, preview finishing, and request reliable B2B quotations in one place.',
  'hero.cta.browse': 'Browse All Packaging',
  'hero.cta.upload': 'Upload Reference Image',
  'hero.cta.quote': 'Get a Quote',
  'hero.cta.searchByPhoto': 'Search by your product Photo',
  'hero.searchByPhoto.title': 'Search by Photo',
  'hero.searchByPhoto.dragDrop': 'Drag & drop an image here, or click to upload',
  'hero.searchByPhoto.maxSize': 'Supports all image formats, max 10MB',
  'hero.searchByPhoto.or': 'or',
  'hero.searchByPhoto.upload': 'Upload Image',
  'hero.searchByPhoto.takePhoto': 'Take Photo',

  // Announcement
  'announcement.label': 'Announcement',
  'announcement.viewAll': 'View All',

  // Value Cards
  'value.sectionTitle': 'Our Strength',
  'value.sectionSubtitle': 'Your Professional & Reliable Partner',
  'value.suppliers.title': '1000+ Supplier Network',
  'value.suppliers.desc': 'Access verified packaging manufacturers across China with standardized product data and transparent pricing.',
  'value.moq.title': 'Low MOQ Options',
  'value.moq.desc': 'Find suppliers offering small minimum order quantities perfect for startups, samples, and testing markets.',
  'value.ai.title': 'AI Finishing Preview',
  'value.ai.desc': 'See how glossy caps, frosted bodies, metallic finishes, and matte textures look before ordering samples.',
  'value.transparent.title': 'Transparent Quotation & QC',
  'value.transparent.desc': 'Get detailed quotations including finishing costs, and track quality control at every production stage.',

  // Categories
  'categories.subtitle': 'Our PRODUCTS',
  'categories.title1': 'Browse by',
  'categories.title2': 'Category',
  'categories.airless': 'Airless Bottles',
  'categories.pump': 'Pump Bottles',
  'categories.dropper': 'Dropper Bottles',
  'categories.cream': 'Cream Jars',
  'categories.tubes': 'Tubes',
  'categories.cushion': 'Cushion / Compact Cases',
  'categories.lip': 'Lip / Makeup Packaging',
  'categories.refill': 'Refill Containers',
  'categories.eco': 'Eco Packaging',
  'categories.viewAll': 'View All',

  // AI Preview
  'aiPreview.title': 'Preview AI-Finishing Before Sampling',
  'aiPreview.subtitle': 'Upload your design and see how different finishes transform your packaging in seconds.',
  'aiPreview.glossy': 'Glossy Cap',
  'aiPreview.glossy.desc': 'High-shine reflective finish for premium appeal',
  'aiPreview.frosted': 'Frosted Body',
  'aiPreview.frosted.desc': 'Elegant semi-transparent matte texture',
  'aiPreview.metallic': 'Metallic Finish',
  'aiPreview.metallic.desc': 'Luxurious metal-like surface treatment',
  'aiPreview.matte': 'Soft-Touch Matte',
  'aiPreview.matte.desc': 'Velvet-like tactile coating experience',
  'aiPreview.color': 'Color Change',
  'aiPreview.color.desc': 'Custom Pantone matching and gradients',
  'aiPreview.tryNow': 'Explore Custom Finishes',

  // Quotation Process
  'quotation.title': 'How to Order',
  'quotation.subtitle': 'From discovery to delivery in six simple steps',
  'quotation.step1': 'Select Product',
  'quotation.step1.desc': 'Browse thousands of containers and find the perfect match',
  'quotation.step2': 'Choose Finishing (Optional)',
  'quotation.step2.desc': 'Pick cap styles, colors, textures, and decorations',
  'quotation.step3': 'Request Quote',
  'quotation.step3.desc': 'Get transparent pricing including MOQ and lead time',
  'quotation.step4': 'Sample Making (Optional)',
  'quotation.step4.desc': 'Review physical samples before mass production',
  'quotation.step5': 'Place Order',
  'quotation.step5.desc': 'Confirm order with secure payment and contract',
  'quotation.step6': 'QC & Delivery',
  'quotation.step6.desc': 'Quality inspection and global shipping to your door',

  // Trust
  'trust.label': 'Why Brands Trust Us',
  'trust.title': 'We bridge the gap between global cosmetic brands and verified Chinese packaging suppliers, making sourcing transparent, efficient, and reliable.',
  'trust.suppliers': 'Verified Suppliers',
  'trust.suppliers.desc': 'Every factory is audited and verified before joining our network.',
  'trust.data': 'Standardized Data',
  'trust.data.desc': 'All products use unified spec sheets for easy comparison.',
  'trust.price': 'Transparent Pricing',
  'trust.price.desc': 'No hidden fees. See full cost breakdown upfront.',
  'trust.qc': 'QC Checklist',
  'trust.qc.desc': 'Multi-stage quality control at factory and pre-shipment.',
  'trust.delivery': 'Global Delivery',
  'trust.delivery.desc': 'Door-to-door logistics support for 50+ countries.',
  'trust.stat.suppliers': '1,000+',
  'trust.stat.suppliers.label': 'Verified Suppliers',
  'trust.stat.products': '50,000+',
  'trust.stat.products.label': 'Product SKUs',
  'trust.stat.countries': '50+',
  'trust.stat.countries.label': 'Countries Served',
  'trust.stat.satisfaction': '98%',
  'trust.stat.satisfaction.label': 'Customer Satisfaction',

  // Testimonial
  'testimonial.title': 'What Our Clients Say',
  'testimonial.rating': '4.9 / 5.0',
  'testimonial.review1': '"PackVerse helped us find the exact airless bottles we needed for our skincare line. The AI preview saved us weeks of back-and-forth with suppliers. We got samples in 10 days and our first order in 4 weeks."',
  'testimonial.author1': 'Sarah Kim',
  'testimonial.role1': 'Founder, Lumiere Beauty Co.',
  'testimonial.review2': '"As an OEM company serving Southeast Asian brands, we need reliable packaging sources with low MOQ. This platform is exactly what the industry needed."',
  'testimonial.author2': 'Mark Tan',
  'testimonial.role2': 'Procurement Director, ASEAN Cosmo OEM',

  // Newsletter
  'newsletter.title': 'Subscribe to Our Newsletter',
  'newsletter.subtitle': 'Get the latest packaging trends, new supplier arrivals, and industry insights delivered to your inbox.',
  'newsletter.placeholder': 'Enter your email address',
  'newsletter.button': 'Subscribe',
  'newsletter.success': 'Thank you for subscribing!',
  'newsletter.error': 'Please enter a valid email address.',

  // Footer
  'footer.company': 'Company',
  'footer.about': 'About Us',
  'footer.careers': 'Careers',
  'footer.press': 'Press',
  'footer.blog': 'Blog',
  'footer.packaging': 'Packaging',
  'footer.browse': 'Browse All',
  'footer.categories': 'Categories',
  'footer.others': 'Others',
  'footer.customization': 'Customization',
  'footer.finishing': 'Finishing Options',
  'footer.aiPreview': 'AI Preview',
  'footer.design': 'Design Support',
  'footer.quote': 'Quote',
  'footer.request': 'Request Quote',
  'footer.moq': 'MOQ Guide',
  'footer.pricing': 'Pricing',
  'footer.support': 'Support',
  'footer.help': 'Help Center',
  'footer.shipping': 'Shipping Info',
  'footer.returns': 'Returns',
  'footer.terms': 'Terms of Service',
  'footer.privacy': 'Privacy Policy',
  'footer.contact': 'Contact',
  'footer.rights': 'All rights reserved.',
  'footer.brand': 'PackVerse',
  'footer.tagline': 'Global Cosmetic Packaging Sourcing Portal',
};